module.exports = __webpack_public_path__ + "static/media/sketch1.b7316c24.jpg";